import React, { useEffect, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

const YocoButton = ({ planId, description, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 👑 Plan prices in cents
  const planAmounts = {
    starter: 379900,
    pro: 899900,
    unlimited: 8899900,
  };

  useEffect(() => {
    if (window.YocoSDK) {
      window.yoco = new window.YocoSDK({
        publicKey: "pk_live_77eb01c7V4Gbd648b1d4",  
      });
    }
  }, []);

  const handlePay = async () => {
    const user = auth.currentUser;
    if (!user) {
      alert("Please log in to continue.");
      return;
    }

    if (!window.yoco) {
      alert("⚠️ Yoco SDK not loaded. Please refresh and try again.");
      return;
    }

    setLoading(true);

    window.yoco.showPopup({
      amountInCents: planAmounts[planId] || 200, // 👑 show correct price in popup
      currency: "ZAR",
      name: "InvestorLanes",
      description: description || planId,
      callback: async (result) => {
        if (result.error) {
          alert("❌ Payment failed: " + (result.error.message || "Unknown error"));
          setLoading(false);
          return;
        }

        try {
          const functions = getFunctions();
          const confirmPayment = httpsCallable(functions, "createYocoPayment");

          const res = await confirmPayment({
            token: result.id,
            userId: user.uid,
            planId,
          });

          if (res.data.success) {
            alert("✅ Payment successful!");
            onSuccess?.();
            navigate("/dashboard"); // redirect to dashboard
          } else {
            alert("❌ Payment failed: " + (res.data.error || "Unknown server error"));
          }
        } catch (err) {
          console.error(err);
          alert("⚠️ Something went wrong.Please try again.");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <button
      onClick={handlePay}
      disabled={loading}
      className={`px-6 py-3 rounded-xl font-semibold transition ${
        loading
          ? "bg-gray-400 cursor-not-allowed text-white"
          : "bg-black text-white hover:bg-gray-800"
      }`}
    >
      {loading ? "Processing…" : "Pay"}
    </button>
  );
};

export default YocoButton;
